<template>
    <span @click="openKlaro" class="cursor-pointer">
        {{ title }}
    </span>
</template>

<script lang="ts" setup>
import { defineProps } from 'vue';
import events from '@/events';

const props = defineProps<{
    title: string;
}>();
function openKlaro() {
    events.$emit('show', '');
}
</script>
